import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import ReactPlayer from 'react-player';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonContent,
  IonText,
  IonIcon,
  IonRippleEffect,
  IonBackButton,
  IonImg,
  useIonViewWillLeave
} from '@ionic/react';
import {
  informationCircleOutline,
  chevronDownOutline,
  chevronForwardOutline
} from 'ionicons/icons';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { getUrlFromPath } from 'libs/helpers/helper.lib';

import CustomModal from 'components/CustomModal';
import SanatizedHtml from 'components/SanatizedHtml';

import exerciseStore from 'stores/exercise.store';

import classes from './style.module.scss';

const WorkoutSingle = ({ match }) => {
  const [popoverState, setShowPopover] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  const workoutExercise = exerciseStore.getObject();

  useIonViewWillLeave(() => {
    ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
  }, []);

  return (
    <IonPage id='exercise-single'>
      <IonHeader className={classes.ionHeader}>
        <IonToolbar>
          <div className={classes.exerciseTitleHead}>
            <IonImg
              src={getUrlFromPath(workoutExercise.exercise.thumbnail)}
              alt={workoutExercise.exercise.name}
            />
            <div className={classes.exerciseInfoContainer}>
              <IonButtons slot='start'>
                <IonBackButton />
              </IonButtons>
              <div className={classes.exerciseInfo}>
                <IonText className='big'>
                  {workoutExercise.exercise.name}
                </IonText>
                <div className={classes.exerciseMcdRnNotes}>
                  <div className={classes.exerciseMcdRn}>
                    <IonText className='big'>
                      {workoutExercise.exercise.equipments.length === 0
                        ? '--'
                        : workoutExercise.exercise.equipments
                            .map((equipment) => equipment.name)
                            .join(', ')}
                    </IonText>
                    <IonText className='small light'>Equipment</IonText>
                  </div>
                  <div className={classes.exerciseMcdRn}>
                    <IonText className='big'>
                      {workoutExercise?.exercise.laterality === 'UNILATERAL'  ? (<>
                        x {workoutExercise.repetition_numbers_left} L
                        x {workoutExercise.repetition_numbers_right} R
                      </>) : (
                        <>
                          x {workoutExercise.repetition_numbers_left} 
                        </>
                      )}
                      
                    </IonText>
                    <IonText className='small light'>
                      Repetition Numbers
                    </IonText>
                  </div>
                  {/* <IonIcon
                    icon={informationCircleOutline}
                    size='large'
                    onClick={(e) => setShowPopover(true)}
                  />
                  <CustomModal
                    isOpen={popoverState}
                    dismiss={() => setShowPopover(false)}
                    title='Notes'
                    content={workoutExercise.notes}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className={classes.exerciseDetailInfo}>
          <div className={classes.exerciseDetailInfoRow}>
            <div className={classes.exerciseDetailInfoColumn}>
              <IonText className='big'>
                {workoutExercise.exercise.primary_joint}
              </IonText>
              <IonText className='small light'>Primary Joint</IonText>
            </div>
            <div className={classes.exerciseDetailInfoColumn}>
              <IonText className='big'>
                {workoutExercise.exercise.primary_plane_motion}
              </IonText>
              <IonText className='small light'>Primary Plane Motion</IonText>
            </div>
          </div>
          <div className={classes.exerciseDetailInfoRow}>
            {/* <div className={classes.exerciseDetailInfoColumn}>
              <IonText className='big'>
                {workoutExercise.exercise.secondary_plane_motion ?? 'NA'}
              </IonText>
              <IonText className='small light'>Secondary Plane Motion</IonText>
            </div> */}
            {/* <div className={classes.exerciseDetailInfoColumn}>
              <IonText className='big'>
                {workoutExercise.exercise.equipments
                  .map((equipment) => equipment.name)
                  .join(', ')}
              </IonText>
              <IonText className='small light'>Equipment</IonText>
            </div> */}
          </div>
          {workoutExercise.notes && (
            <>
              <div className={classes.exerciseInfoNoteDivider}></div>
              <div className={classes.exerciseNoteContainer}>
                <IonText className='big'>Notes </IonText>
                <br />
                <IonText className='small light'>
                  <SanatizedHtml dirtyHtml={workoutExercise.notes} />
                </IonText>
              </div>
            </>
          )}
        </div>

        <div className={classes.exerciseVideoContainer}>
          <ReactPlayer
            url={workoutExercise.exercise.video_link}
            controls={true}
            width='100%'
            height='100%'
            stopOnUnmount={true}
            onPlay={() => {
              ScreenOrientation.unlock();
            }}
            onPause={() => {
              ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
            }}
            onEnded={() => {
              ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
            }}
            config={{
              youtube: {
                playerVars: {
                  showinfo: 0,
                  modestbranding: 1,
                  rel: 0
                },
                embedOptions: {
                  height: 240
                }
              },
              vimeo: {
                playerOptions: {
                  responsive: true
                }
              }
            }}
          />
        </div>
        <div className={classes.exerciseDescription}>
          <div
            className={`${classes.exerciseDecButton} ion-activatable ripple-parent`}
            onClick={() => setShowDesc((prevState) => !prevState)}
          >
            <IonText class='big'>Description</IonText>
            <IonIcon
              icon={showDesc ? chevronDownOutline : chevronForwardOutline}
            />
            <IonRippleEffect></IonRippleEffect>
          </div>
          {showDesc && (
            <div className={classes.exerciseDescriptionDetails}>
              <SanatizedHtml dirtyHtml={workoutExercise.exercise.description} />
            </div>
          )}
          <div className={classes.exerciseDecButtonDivider}></div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default observer(WorkoutSingle);
